module.exports = __webpack_public_path__ + "static/img/storebg.ba5853e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storebg.jpg
// module id = CQF9
// module chunks = 1